import React, { Suspense } from 'react';

import { IApplicationPage } from 'application/pages/types';
import PAGES_CONST from 'application/pages/constants';
import { LocalAccessRoles } from 'application/providers/AuthProvider';
import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

export type TWebPlayerPathParams = {
  bindingCode?: string;
};

const Renderer = React.lazy(() => import('./renderer'));

export const WEB_PLAYER_PAGE_PATH = '/web-player/:bindingCode';

const WebPlayerPageWrapper: IApplicationPage = () => (
  <Suspense fallback={<LoadingScreen delay={PAGES_CONST.LOADER_SCREEN_DELAY} />}>
    <Renderer />
  </Suspense>
);

WebPlayerPageWrapper.config = {
  routes: [
    {
      path: WEB_PLAYER_PAGE_PATH,
    },
  ],
  access: [LocalAccessRoles.ANONYMOUS, LocalAccessRoles.AUTHORIZED],
};

export default WebPlayerPageWrapper;
